<template>
  <div class="patient" v-if="patient">
    <Breadcrumbs :items="breadcrumbs">
      <div class="breadcrumbs-actions">
        <rp-sprite @click.native="historyModal = !historyModal" class="create-icon" name="history"/>
        <router-link :to="{ name: 'edit-patient', params: { id: this.$route.params.id}}">
          <rp-sprite class="create-icon" name="create"/>
        </router-link>
        <rp-sprite @click.native="activeConfirm = !activeConfirm" class="create-icon" name="delete_outline"/>
      </div>
    </Breadcrumbs>

    <div class="content">
      <div class="patient-info">
        <div class="info-group">
          <h3>Patient ID</h3>
          <p>{{patient.patient_id ? patient.patient_id : 'NOT PROVIDED'}}</p>
        </div>
        <div class="info-group">
          <h3>First Name</h3>
          <p>{{patient.profile.first_name ? patient.profile.first_name : 'NOT PROVIDED'}}</p>
        </div>
        <div class="info-group">
          <h3>Last Name</h3>
          <p>{{patient.profile.last_name ? patient.profile.last_name : 'NOT PROVIDED'}}</p>
        </div>
        <div class="info-group">
          <h3>Gender</h3>
          <p>{{patient.profile.gender | genderFilter}}</p>
        </div>
        <div class="info-group">
          <h3>Year of birth</h3>
          <p>{{patient.profile.yob ? patient.profile.yob : 'NOT PROVIDED'}}</p>
        </div>
        <div class="info-group">
          <h3>Email Address</h3>
          <p>{{patient.email ? patient.email : 'NOT PROVIDED'}}</p>
        </div>
        <div class="info-group">
          <h3>Language Spoken</h3>
          <p>{{patient.locale.name ? patient.locale.name : 'NOT PROVIDED'}}</p>
        </div>
        <!-- <div class="info-group">
          <h3>Questionnaires</h3>
          <p>
            <router-link
              class="btn"
              :to="{ name: 'patient-questionnaires', params: {patientId: patient.profile.id } }">
              View All
            </router-link>
          </p>
        </div> -->
        <hr />
        <rp-table
          name="operations"
          :results="getOperations"
          :key="update"
          :headings="[{heading: 'Surgery Date', key: 'performedAt'}, {heading: 'Eye', key: 'eye'}]"
          @rowClick="onRowClick" />

        <rp-button
          class="btn primary custom"
          v-if="operations.length === 0"
          @click="scheduleSurgery()">
          add surgery
        </rp-button>
      </div>

      <rp-overlay :active="activeConfirm">
        <rp-delete-confirm
          icon="warning"
          userType="Patient"
          messageType='Delete '
          :userName="userName"
          :cancel="cancelDeletion"
          :confirm="confirmDeletion"/>
      </rp-overlay>

      <rp-overlay :active="activeDelete">
        <rp-alert
          icon="done"
          :message="alertMessage"
          :onClick="alertFunction"/>
      </rp-overlay>

      <rp-modal :show="historyModal" :onClose="closeHistory" :closeIcon="true">
        <div class="modal-header">Patient History</div>
        <div class="modal-body">
          <rp-patient-history :patientId="id"/>
        </div>
      </rp-modal>
    </div>
  </div>
</template>

<script>
import Breadcrumbs from '@/components/Breadcrumbs'
import RpSprite from 'raypro_ui/src/components/ui/Sprite'
import Overlay from 'raypro_ui/src/components/ui/Overlay'
import DeleteConfirm from 'raypro_ui/src/components/ui/DeleteConfirm'
import Alert from 'raypro_ui/src/components/ui/Alert'
import Table from 'raypro_ui/src/components/ui/Table'
import PatientHistory from './PatientHistory'
import Modal from '@/components/Modal'
import page from '@/mixins/page'
import Button from 'raypro_ui/src/components/ui/inputs/Button'

// API
import {getPatient, deletePatient, getPatientOperation} from 'raypro_ui/src/api/users'

export default {
  components: {
    Breadcrumbs,
    RpSprite,
    'rp-table': Table,
    'rp-overlay': Overlay,
    'rp-alert': Alert,
    'rp-delete-confirm': DeleteConfirm,
    'rp-patient-history': PatientHistory,
    'rp-modal': Modal,
    'rp-button': Button
  },

  data() {
    return {
      operations: [],
      patient: null,
      activeConfirm: false,
      historyModal: false,
      activeDelete: false,
      update: 0,
      title: 'Patient',
      page: {
        totalPages: 1,
        totalentries: 0,
        pageSize: 10,
        pageNumber: 1
      }
    }
  },

  props: {id: String},

  watch: {
    id: function() {
      this.getPatientData()
    }
  },

  mixins: [page],
  filters: {
    genderFilter(gender) {
      if(gender === 'PATIENT DELETED') {
        return gender
      }
      if(gender === 'M') {
        return 'Male'
      }
      if(gender === 'F') {
        return 'Female'
      }
      if(gender === 'O') {
        return 'Prefer not to say'
      }

      return 'NOT PROVIDED'
    }
  },

  mounted() {
    this.getPatientData()
  },

  computed: {
    userName() {
      return `${this.patient.profile.first_name} ${this.patient.profile.last_name}`
    },

    alertMessage() {
      return `Patient ${this.patient.profile.first_name} ${this.patient.profile.last_name} deleted successfully!`
    },

    salutation() {
      return this.patient.profile.salutation || ''
    },

    currentBreadcrumb() {
      return `${this.salutation} ${this.userName}`
    },

    breadcrumbs() {
      return [
        {
          label: 'My Patients',
          link: 'all-patients'
        },
        {label: this.getFullName(this.patient)}
      ]
    }
  },

  methods: {
    getPatientData() {
      getPatient(this.id).then(({data}) => {
        this.patient = data
        this.update++
      })
    },

    getFullName(data) {
      const profile = data.profile
      let name = ''

      if(profile) {
        if(!profile.first_name && !profile.last_name) {
          return 'NOT PROVIDED'
        }
        if(profile.first_name) {
          name += `${profile.first_name}`
        }
        if(profile.last_name) {
          name += ` ${profile.last_name}`
        }
        return name
      }
    },

    closeHistory() {
      this.historyModal = false
    },

    alertFunction() {
      this.$router.push({name: 'all-patients'})
    },

    cancelDeletion() {
      this.activeConfirm = !this.activeConfirm
    },

    confirmDeletion() {
      deletePatient(this.id)
        .then(() => {
          this.activeConfirm = !this.activeConfirm
          this.activeDelete = !this.activeDelete
        })
    },

    onPatientEdit() {
      const id = this.$route.params.id

      this.$router.push({name: 'edit-patient', params: {id}})
    },
    onRowClick(row) {
      this.$router.push(`/operations/${row.id}`)
    },

    getOperations(page) {
      const patientId = this.$route.params.id
      const userId = this.$store.getters.authUser.id

      return getPatientOperation(userId, patientId, page).then(({data, page}) => {
        this.page = page

        const mapped = data.map((operation) => {
          return {
            id: operation.id,
            performedAt: (new Date(operation.performed_at)).toLocaleDateString(),
            eye: operation.operation_iols.map((item) => {
              return item.eye === 'L' ? 'Left' : 'Right'
            }).join(', ')
          }
        })

        this.operations = mapped

        return {
          data: mapped,
          page
        }
      })
    },

    scheduleSurgery() {
      this.$router.push({name: 'add-operation', params: {patientEmail: this.patient.email}})
    }
  }
}
</script>

<style lang="sass" scoped>
@import 'raypro_ui/src/styles/base/_variables.sass'
@import 'raypro_ui/src/styles/helpers/_mixins.sass'

.btn.custom
  width: 100%
  color: $color-text-invert
  border: 1px solid $color-grey

.patient
  .content
    display: flex
    flex-direction: column

    @include media($media-medium)
      padding: 0 40px
      flex-direction: row
      justify-content: space-between

    .patient-info
      @include media($media-medium)
        width: 40%

      .info-group
        display: flex
        flex-direction: column

        @include media($media-medium)
          flex-direction: row
          align-items: center

        h3
          display: inline-flex
          width: 150px
          min-width: 150px
          margin: 0
          text-transform: initial
          font-weight: lighter
        p
          display: inline-flex
          line-height: 1
          font-weight: bold
          word-break: break-word
      hr
        margin: 20px 0 36px
        border-top: 1px solid $color-grey-dark

    .modal-header
      padding: 20px
      font-size: 20px
      border-bottom: 2px solid #e2e4e4
      color: $color-text

    .modal-body
      min-height: 500px
</style>



// WEBPACK FOOTER //
// src/components/pages/Patients/Patient.vue